export const ROOT_FOLDER = '/rjsapp';
export const ROOT_FOLDER_2 = '/join';
export const HOME = 'home';
export const INDEX = 'index';
export const MEMBER = 'member';
export const PROSPECT = 'prospect';
export const FEED_HOME = 'feed-home';
export const NOTIFICATION = 'notification';
export const LIKES = 'likes';
export const BROWSER_NOTIFICATION = 'browser-notification';
export const MEMBER_PROFILE = 'member/profile';
export const MEMBER_PROFILE_MOBILE_SCREEN = 'member-profile-popup';
export const PROSPECT_PROFILE = 'prospect/profile';
export const TEST_DESKTOP = 'test-desktop';
export const LOGIN = 'login';
export const LOCATION = 'location';
export const TELL_US_ABOUT_YOUR_SELF_S1 = 'aboutyouself1';
export const WHAT_ARE_YOUR_INTERESTS = 'interests';
export const INTRODUCE_YOUR_SELF = 'introduce-yourself';
export const SPLASH_SCREEN = 'splash';
export const FORGOT_PASSWORD = 'forgot-password';
export const RESET_PASSWORD = 'reset-password';
export const CREATE_ACCOUNT = 'registration';
export const UPDATE_INFO = 'update-info';
export const FACEBOOK_IMPORT_INFO = 'import-info';
export const UPLOAD_PHOTO = 'MemberPhoto/?upload=true';
export const SETTING = 'home/setting';
export const CHAT_ROOMS_SETTING = 'chat-rooms/setting';
export const CHAT_ROOMS = 'chat-rooms';
export const MAIN_SETTING = 'setting';
export const EDIT_SETTING_INFO = 'edit-setting-info';
export const PORTABLE_SUBSCRIBER_MOBILE = 'portable-subscriber-mobile';
export const GROUPCHAT = 'groupchat';
export const FRIEND = 'friend';
export const DATE_INTEREST = 'date-interest';
export const EVENTS = 'events';
export const CREATE = 'create';
export const EDIT = 'edit';
export const EVENT_DETAIL = 'event-detail';
export const CLUB_DETAIL = 'club-detail';
export const USER = 'user';
export const EVENT = 'event';
export const JOIN_NOW = 'joinNow/v2/';
export const DATE_FINDER = '/DateFinder';
export const AMATEUR_PICS = '/Amateurs';
export const ADULT_FORUMS = '/Adult-Forums';
export const TRAVEL = '/MemberProfile/DateAway.aspx';
export const VERIFY_PROFILE = 'verification';
export const ACCOUNT_SETTING = 'account-setting';
export const EMAIL = 'email';
export const USERNAME = 'username';
export const PASSWORD = 'password';
export const PHONE_UPDATE = 'update-phone-number';
export const PHONE_ADD = 'add-phone-number';
export const PHONE_VERIFY = 'verify-phone-number';
export const AUTHORIZE = 'authorize';
export const IMAGES_GALLERY = 'image-gallery';
export const PROFILE = 'profile';
export const ACCOUNT = 'account';
export const PRIVACY = 'privacy';
export const LIST = 'list';
export const USER_LIST = 'user-list';
export const VALIDATION = 'validation';
export const PHOTO = 'photo';
export const GALLERY = 'gallery';
export const ACCESS_LIST = 'access-list';
export const BLOCK_LIST = 'block-list';
export const IGNORE = 'ignore';
export const LEGAL = 'legal';
export const PAYMENT_GATEWAY_PAGE = 'payment';
export const RESTRICTED_MEDIA = 'restricted-media';
export const PAYMENT_OPTION = 'PaymentOptions';
export const EDIT_PROFILE = 'edit-profile';
export const EDIT_PROFILE_DK = 'edit-profile';
export const EDIT_GENERAL_INFO = 'general-info';
export const UPGRADE_MEMBER = 'upgrade';
export const INTENTIONS = 'intentions';
export const INTERESTS = 'interests';
export const DESCRIPTION = 'description';
export const PARTICIPATION = 'participation';
export const INTIMATE_INFO = 'intimate-info';
export const PARTNER_DESCRIPTION = 'partner-description';
export const IDEAL_PARTNER = 'ideal-partner';
export const NOT_FOUND = 'page-not-found';
export const SUBSCRIPTION = 'subscription';
export const ORDERS = 'orders';
export const MANAGE = 'manage';
export const WALLET = 'wallet';
export const MANAGE_SUBSCRIPTION = 'manage-subscription';
export const ADD_YOUR_PHOTO = 'add-your-photo';
export const ACCOUNT_PAUSE = 'account-pause';
export const ACCOUNT_INACTIVE = 'account-inactive';
export const DATE_FINDER_PAGE = 'date-finder';
export const JOIN_NOW_STEP_1 = 'joinNow/v2/1';
export const SEARCH = 'search';
export const DATE_FINDER_MY_DATE = 'my-dates';
export const DATE_FINDER_ADD_DATE = 'add-dates';
export const INTEREST_PAGE = 'interest';
export const DATE_FINDER_CUSTOMISE_DATE = 'customise-date';
export const TRAVEL_PLAN = 'travel-plan';
export const MY_TRAVEL_PLAN = 'my-travel-plan';
export const ADD_TRAVEL_PLAN = 'add-travel-plan';
export const EDIT_TRAVEL_PLAN = 'edit-travel-plan';
export const DESTINATION_TRAVEL_PLAN = 'destinations';
export const CLUB_ORGANISERS = 'club-and-organisers';
export const UPDATE_CARD_DETAIL = 'update-card-detail';
export const FORUMS = 'forums';
export const FORUM_ACTIVE = 'active';
export const FORUM_RECENT = 'recent';
export const FORUM_BOARD = 'board';
export const REGIONAL_FORUMS = 'regional-forums';
export const BOARDS = 'boards';
export const FORUM_SUMMARIES = 'summaries';
export const TOPIC = 'topic';
export const MY_FORUMS = 'my-forums';
export const TOPIC_SEARCH = 'topic-search';
export const TRANSFORM_PAGE = 'transform-page';
export const HELP_SUPPORT = 'help';
export const SUPPORT_VIEW = 'support';
export const ABOUT_RHP = 'about';
export const TICKET_LIST = 'ticket-list';
export const TICKET_DETAIL = 'ticket-detail';
export const ADD_TOPIC = 'add-topic';
export const ACTIVE_USERS = 'active-users';
export const COMMUNITY = 'community';
export const DETAIL = 'detail';
export const PUSH_NOTIFICATION = 'push-notification';
export const EMAIL_NOTIFICATION = 'email-notification';
export const TEMP_RHP = 'temp-rhp';
export const HELP_AND_SUPPORT = 'help-support';
export const ARTICLES = 'articles';
export const STORIES = 'stories';
export const MY_STORIES = 'my-stories';
export const ASK_SAMANTHA = 'ask-samantha';
export const ON_THE_GROUND = 'on-the-ground';
export const VIDEO = 'video';
export const TESTIMONIALS = 'testimonials';
export const MANAGER_CONVERSATION_CREDITS = 'manager-conversation-credits';
export const COMPETITION = 'competition';
export const AUTHOR_STORIES = 'author-stories';
export const EVENT_DETAIL_SCREEN = 'event-detail-screen';
export const ARTICLE_DETAIL_SCREEN = 'article-detail-screen';
export const AUTHENTICATION_SCREEN = 'authentication-screen';
export const RHP_STORE = 'rhp-store';
export const RHP_CART = 'rhp-cart';
export const RHP_STORE_CHECKOUT = 'check-out';
export const RHP_STORE_PAYMENT = 'payment';
export const RHP_STORE_ORDER_DETAILS = 'order-detail';
export const CONVERSATION_GROUP_CHAT = 'group-chat';
export const ALL_PROPERTY_VIEW = 'all-prop-view';
export const COINS = 'coins';
export const DIAMONDS = 'diamonds';
export const ARTICLE_AUTHOR = 'article-author';
export const POPULAR_RHP_AUTHORS = 'popular-rhp-authors';
export const RECENTLY_VALIDATED = 'recently-validated';
export const CLUB_REVIEW_LIST = 'club-review-list';
export const QUICK_REGISTRATION = 'quick-registration';
export const QUICK_REGISTRATION_2 = 'general4.aspx';
export const QUICK_REGISTRATION_3 = 'quick-reg-v2';
export const QUICK_REGISTRATION_4 = 'quick-reg-v2-1';
export const GROUP_CHAT_JOIN_BY_LINK = 'group-chat-link';
export const QUICK_WITH_EMAIL = 'email';
export const QUICK_WITH_PHONE = 'phone';
export const QUICK_WITH_OTHER = 'other';
export const TEST_MODAL = 'test-modal';
export const ERROR_PAGE = 'error-page';
export const SPOTLIGHT = 'spotlight';
export const DRAG_DROP_VIEW = 'drag-drop-view';
export const GROUPS_VIEW = 'groups';
export const GROUPS_JOINED = 'groups-joined';
export const GROUPS_SUGGESTED = 'groups-suggested';
export const MY_GROUPS_VIEW = 'my-group';
export const GROUP_DETAIL_VIEW = 'group/detail';
export const GROUP_CREATE = 'group/create';
export const GROUP_CREATE_POST = 'group/create-post';
export const GROUP_ALBUM_DETAIL_VIEW = 'group/album/detail';
export const GROUP_DETAIL_NOTIFICATION_VIEW = 'group/detail/notification';
export const GROUP_POST_DETAIL_VIEW = 'group/post/detail';
export const GROUP_NOTIFICATION_DETAIL = 'group/notification/detail';
export const GROUP_DETAIL_MEMBER = 'group/detail/member';
export const EVENT_DETAIL_MEMBER = 'event/detail/member';
export const JOIN_QUICK_REGISTRATION_1 = 'Joinbase.aspx';
export const JOIN_QUICK_REGISTRATION_2 = 'general6.aspx';
export const JOIN_QUICK_REGISTRATION_3 = 'general4a.aspx';
export const JOIN_QUICK_REGISTRATION_4 = 'general17.aspx';
export const JOIN_QUICK_REGISTRATION_5 = 'general15.aspx';
export const JOIN_QUICK_REGISTRATION_6 = 'general13.aspx';
export const JOIN_QUICK_REGISTRATION_7 = 'general12.aspx';
export const JOIN_QUICK_REGISTRATION_8 = 'dating8.aspx';
export const NOTIFICATION_GROUP_ACTIVE = 'group/active';
export const NOTIFICATION_GROUP_JOIN_REQUEST = 'group/join-request';
export const GROUP_SUGGESTED_MEMBERS = 'suggest';
export const EVENT_SUGGESTED_MEMBERS = 'suggest';
export const INVITATION = 'invitation';
export const MESSENGER_ANALYTICS = 'messenger-analytics';
export const GROUP_JOINS_VIEW = 'group/joins';
export const PROFILE_ACCOUNT = 'profile-account';
export const QUICK_REG_SHORT_LINK = 'qr';
